import { render } from "./PopUpCancelSubscription.vue?vue&type=template&id=5848f151"
import script from "./PopUpCancelSubscription.vue?vue&type=script&lang=js"
export * from "./PopUpCancelSubscription.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__